module.exports = __webpack_public_path__ + "img/file.15695e04.svg";